import React from 'react'
import Contact from '../components/Contact/Contact'



const layoutStyle = {
    padding: '120px 0px 100px 0px'
}

const ContactPage = () => {
    return (
        <div style={layoutStyle}>
            <Contact />
        </div>
    )
}

export default ContactPage
